import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="blog-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-12">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Insights</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mb-6 max-w-4xl">
          Notes from <span className="text-gradient-animate">the studio.</span>
        </h1>
      </section>

      <section className="container mx-auto px-4 pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((p) => (
          <Link to={`/blog/${p.slug}`} key={p.id} data-testid={`blog-${p.slug}`}
            className="group bg-white border border-zinc-200 hover:border-[#FF007F] rounded-2xl overflow-hidden transition">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            </div>
            <div className="p-6">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[#FF007F] mb-2">{p.category}</div>
              <h3 className="font-display font-bold text-xl mb-3 group-hover:text-[#FF007F] transition leading-tight">{p.title}</h3>
              <p className="text-sm text-zinc-600 line-clamp-2 mb-4">{p.excerpt}</p>
              <span className="text-sm font-semibold text-[#0A1128] inline-flex items-center gap-1">
                Read article <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
              </span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
